module.exports = __webpack_public_path__ + "img/logo_ccs_login@2x.38fa7afd.png";